// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconAnnotationsAnnotationFreehand_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M14.1379 10.9539C13.3126 12.089 12.0019 13.1004 10.6503 13.7784L1.46878 3.19235C3.55092 1.80692 4.9671 1.85271 5.89484 2.22419C7.04521 2.68482 7.83464 3.78927 8.29769 4.68018C8.53059 5.12826 8.84819 5.49582 9.30102 5.71989C9.7273 5.93082 10.1632 5.95687 10.5008 5.95489C10.7199 5.9536 10.9214 5.94281 11.1208 5.93213C11.5954 5.90671 12.0576 5.88196 12.713 5.98771C13.4923 6.11344 14.1707 6.53741 14.5408 7.13648C15.3031 8.37072 15.0764 9.66317 14.1379 10.9539Z" class="svg-bg-stroke" stroke-width="2"/>
</svg>
`;
/**
 * IconAnnotationsAnnotationFreehand is a generated icon component.
 */
let IconAnnotationsAnnotationFreehand = IconAnnotationsAnnotationFreehand_1 = class IconAnnotationsAnnotationFreehand extends IconBaseElement {
    render() {
        return html `${IconAnnotationsAnnotationFreehand_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconAnnotationsAnnotationFreehand.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconAnnotationsAnnotationFreehand = IconAnnotationsAnnotationFreehand_1 = __decorate([
    customElement('zui-icon-annotations-annotation-freehand')
], IconAnnotationsAnnotationFreehand);
export { IconAnnotationsAnnotationFreehand };
